module.exports = __webpack_public_path__ + "img/webp-puppy-main-hero.203debf2.webp";